import { FC } from 'react';
import {
  IProductEnhancerField,
  EProductEnhancerFieldTypes
} from '../../../types';
import {
  OriginalTagField,
  OriginalTitleField,
  OriginalTextareaField,
  OriginalLabelValueField
} from '../components';

// TODO @Evgeniy check with strict null
export const ORIGINAL_FIELD_TO_COMPONENT: Record<
  EProductEnhancerFieldTypes,
  FC<{ field: IProductEnhancerField }>
> = {
  [EProductEnhancerFieldTypes.TAG]: OriginalTagField,
  [EProductEnhancerFieldTypes.TITLE]: OriginalTitleField,
  [EProductEnhancerFieldTypes.TEXTAREA]: OriginalTextareaField,
  [EProductEnhancerFieldTypes.LABEL_VALUE]: OriginalLabelValueField
};
